// Purpose: centered empty-state shell. Illustration slot + heading +
// description + optional CTA. Illustrations land in a later commit;
// callers can pass any SVG/ReactNode as the `illustration` prop.

import type { ReactNode } from 'react';

export interface EmptyStateProps {
  illustration?: ReactNode;
  title: string;
  description?: ReactNode;
  action?: ReactNode;
  className?: string;
}

export function EmptyState({
  illustration,
  title,
  description,
  action,
  className,
}: EmptyStateProps) {
  return (
    <div
      className={['flex flex-col items-center gap-4 py-12 px-6 text-center', className ?? ''].join(
        ' '
      )}
    >
      {illustration ? (
        <div aria-hidden className="text-fg-muted mb-2">
          {illustration}
        </div>
      ) : null}
      <h3 className="text-heading-m text-fg-primary">{title}</h3>
      {description ? (
        <p className="text-body-m text-fg-secondary max-w-[480px]">{description}</p>
      ) : null}
      {action ? <div className="mt-2">{action}</div> : null}
    </div>
  );
}
